// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n/* 修复input 背景不协调 和光标变色 */\n\n/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */", ""]);
// Exports
module.exports = exports;
